import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import PageTitle from "components/PageTitle";
import { SITE_KEY } from "config/recaptcha";
import SignInForm from "./SignInForm";

const SignIn = () => {
  return (
    <div className="page-body">
      <PageTitle
        align="center"
        title="Login WeCare4&reg;"
        registration={true}
      />

      <div className="content-container">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-4 offset-lg-4">
              <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
                <SignInForm />
              </GoogleReCaptchaProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
